import React, { useState } from 'react';

import styled from 'styled-components';

import { useUserPermission } from '@contexts/UserContext';

//import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

import ContactDetailsHeaderStatement from '@components/ContactDetails/CommonComponents/ContactDetailsHeaderStatement';
import ExportContact from '@components/ContactDetails/CommonComponents/ExportContact';

import ContactDetailsActions from '@components/ContactDetails/ContactDetailsHeader/ContactDetailsActions';
import ObjectHistory from '@components/CreatedBy/ObjectHistory';
import FullFeatures from '@components/Features/FullFeatures';
import NwDrawer from '@components/Gui/NwDrawer';
import ObjectLogHistories from '@components/ObjectLogHistories/ObjectLogHistories';
import PermissionBlock from '@components/PermissionBlock/PermissionBlock';

// import NwIcon from '@components/Gui/NwIcon';
// import PermissionBlock from '@components/PermissionBlock';
// import { useUserPermission } from '@contexts/UserContext';

const Actions = styled.div`
    display: flex;
    align-items: center;
    margin-right: 0.5rem;
    /* larghezza fissa: lo spazio residuo va alle feature, che scorrono */
    flex: 0 0 auto;

    svg {
        font-size: 1.3rem;
        margin: 0 0.75rem;
        cursor: pointer;
    }
`;

const ModelDetailsHeaderActions = ({ currentContact, disableStatement, onOpenStatements }) => {
    const [isOpenHistory, setIsOpenHistory] = useState(false);
    const LogsOnContacts = useUserPermission(
        'LogsOnContacts',
        currentContact && currentContact.Users.map((user) => user.UserID)
    );

    const handleOpenHistory = () => {
        setIsOpenHistory(true);
    };

    const handleCloseHistory = () => {
        setIsOpenHistory(false);
    };

    return (
        <>
            <Actions>
                <FullFeatures iconSize="lg" hideIfEmpty currentContact={currentContact} />
                {!disableStatement && (
                    <ContactDetailsHeaderStatement
                        contact={currentContact}
                        type="model"
                        iconSize="lg"
                        onOpenStatements={onOpenStatements}
                    />
                )}
                <ContactDetailsActions contact={currentContact} />
                <PermissionBlock
                    permission={LogsOnContacts}
                    content={<ObjectHistory onIconClick={handleOpenHistory} iconOnly object={currentContact} />}
                />
                <ExportContact contact={currentContact} type="model" />
            </Actions>
            {isOpenHistory && (
                <NwDrawer title="Model Logs" onClose={handleCloseHistory}>
                    <ObjectLogHistories objectId={currentContact.ID} type="model" />
                </NwDrawer>
            )}
        </>
    );
};

export default ModelDetailsHeaderActions;
